module.exports = "/_next/static/images/safe-and-reliable-31b4203c2df462aaa38d7d3f192b1e80.png";